import React from "react";
import { format } from "date-fns";

import AccordionItem from "components/__reusable/AccordionItem";

interface SystemInfoListItemProps {
  title: string;
  startDate: Date;
  memo: string;
}

const urlRegex = /(https?:\/\/[^\s]+)/g;
const isUrl = (value: string) => /^https?:\/\/[^\s]+$/.test(value);

const renderMemoWithLinks = (memo: string) => {
  const lines = memo.split("\n");

  return lines.map((line, lineIndex) => {
    const parts = line.split(urlRegex);

    return (
      <React.Fragment key={`${line}-${lineIndex}`}>
        {parts.map((part, partIndex) => {
          if (isUrl(part)) {
            return (
              <a
                key={`${part}-${partIndex}`}
                href={part}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#346498] underline break-all"
                onClick={(e) => e.stopPropagation()}
              >
                {part}
              </a>
            );
          }

          return (
            <React.Fragment key={`${part}-${partIndex}`}>{part}</React.Fragment>
          );
        })}
        {lineIndex < lines.length - 1 && <br />}
      </React.Fragment>
    );
  });
};

const SystemInfoListItem: React.FC<SystemInfoListItemProps> = ({
  title,
  startDate,
  memo,
}) => {
  return (
    <AccordionItem
      titleElement={
        <div className="w-full lg:flex text-lg lg:space-x-3">
          <p className="w-[10%] text-primary">
            {format(new Date(startDate), "yyyy.MM.dd")}
          </p>
          <p className="flex-1 font-semibold text-xl">{title}</p>
        </div>
      }
      contentElement={
        <div className="p-2 bg-[#fdf1f3] text-lg text-[#707070] whitespace-pre-wrap break-words">
          {renderMemoWithLinks(memo)}
        </div>
      }
    />
  );
};

export default SystemInfoListItem;
